import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import zoom from 'lightgallery/plugins/zoom';
import { isYoutubeVideo, initYTPlayer, loadYouTubeAPI } from '../helpers/youtubeHelper';

/**
 * Open YouTube video in lightbox
 * @requires https://github.com/sachinchoolur/lightGallery
 */

const lightGalleryKey = "D4194FDD-48924833-A54AECA3-D6F8E646";

//- Stop background scroll when video modal is opened
function stopBackgroundScroll(button: HTMLElement) {
    button.addEventListener('lgAfterOpen', function () {
        let body = document.getElementsByTagName('body')[0];
        body.classList.add('overflow-hidden');
    });
}

//- Allow background scroll when video modal is closed
function allowBackgroundScroll(button: HTMLElement) {
    button.addEventListener('lgBeforeClose', function () {
        let body = document.getElementsByTagName('body')[0];
        body.classList.remove('overflow-hidden');
        button.focus();
    });
}


export const videoButton = () => {
    let videoButtons = document.querySelectorAll('[data-bs-toggle="video"]') as NodeListOf<HTMLElement>;
    videoButtons.forEach((button) => {
        stopBackgroundScroll(button);
        allowBackgroundScroll(button);
        const gallery = lightGallery(button, {
            selector: 'this',
            plugins: [lgVideo],
            licenseKey: lightGalleryKey,
            download: false,
            counter: false,
            enableDrag: false,
            enableSwipe: false,
            youTubePlayerParams: {
                modestbranding: 1,
                showinfo: 0,
                rel: 0,
                enablejsapi: 1
            },
            vimeoPlayerParams: {
                byline: 0,
                portrait: 0,
                color: '6366f1'
            },
            mobileSettings: {
                showCloseIcon: true
            }
        });


        if(button.dataset.src && !isYoutubeVideo(button.dataset.src)) return;

        button.addEventListener('lgSlideItemLoad', async (event) => {
            const index = event.detail.index;
            const slideEl = gallery.getSlideItem(index);
            const domSlide = slideEl.firstElement as HTMLElement;
            if (!domSlide) return;

            // Wait for iframe to be on DOM
            const iframe = await new Promise<HTMLIFrameElement>((resolve) => {
                const check = () => {
                    const iframe = domSlide.querySelector('iframe');
                    if (iframe) {
                        resolve(iframe);
                    } else {
                        setTimeout(check, 1000);
                    }
                };
                check();
            });

            await loadYouTubeAPI();
            initYTPlayer(iframe, {
                "onStateChange": (event: { data: number | any; }) => {
                    if (event.data == 0) {
                        gallery.closeGallery();
                    }
                },
            })
        });
    })
};


export const imageModal = () => {
    let imageButtons = document.querySelectorAll('[data-bs-toggle="imageModal"]') as NodeListOf<HTMLElement>;
    imageButtons.forEach((button) => {
        stopBackgroundScroll(button);
        allowBackgroundScroll(button);
        lightGallery(button, {
            selector: 'this',
            plugins: [zoom],
            licenseKey: lightGalleryKey,
            download: false,
            getCaptionFromTitleOrAlt: false,
            counter: false,
            showCloseIcon: true,
            enableDrag: false,
            enableSwipe: false,
            trapFocus: true,
            zoomFromOrigin: false,
            mobileSettings: {
                showCloseIcon: true
            }
        });
    })
};
